// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SchemaMigrations_ActionInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SchemaMigrations_ActionInput — body for POST /config/schema_migrations/check
 * and /run. Both act on the whole schema and take NO parameters: an empty
 * JSON object. Declared so the frontend composable names an input contract
 * (rule composable-contract-options) and so a body with unexpected fields
 * is still parsed through the same path as every other action.
 */
import { registerContract } from './validate'

export interface SchemaMigrations_ActionInput {}

registerContract('SchemaMigrations_ActionInput', {})
